// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"243":"4bdd2246e9bfa439","476":"f69090fc4bed88f9"}[chunkId] + ".js";
};